import Image from 'next/image';
import DallasImageProps from '../dallas-image-props';
import AttractNewCarriersSvg from './attract-new-carriers.svg';

export default function DallasImageAttractNewCarriers(props: DallasImageProps) {
  return (
    <Image src={AttractNewCarriersSvg} alt="Attract new clients" {...props} />
  );
}
